module.exports = __webpack_public_path__ + "img/flushed-face.7f4de0d8.png";